/* eslint camelcase: 0, no-unused-expressions: 0 */
/* global FB */

import React from 'react';
import { BootstrapModal } from '../modal/bootstrap-modal';
import { AvatarUpload } from '../inputs/avatar-upload';
import { FormBuilder } from '../forms/form';

export class AvatarModal extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      errorMsg: '',
      showButton: false
    };
    this.uploadAvatarCb = this.uploadAvatarCb.bind(this);
    this.submitPhoto = this.submitPhoto.bind(this);
    this.avatarForm = this.avatarForm.bind(this);
    this.avatarUploader = this.avatarUploader.bind(this);
    this.submitPhotoCb = this.submitPhotoCb.bind(this);
  }

  uploadAvatar (profileBody, callback) {
    callback();
  }

  uploadAvatarCb (croppedProfileURL, setImgState) {
    setImgState(croppedProfileURL);
    this.setState({ showButton: true });
  }

  submitPhoto (e, callback, ref, profileBody) {
    this.props.updateProfile(profileBody, callback);
  }

  submitPhotoCb (res) {
    if (res.error || 400 <= res.statusCode) {
      return this.setState({ errorMsg: 'Something went wrong. Please refresh and try again later.' });
    }
    return this.props.updateProfileCb();
  }

  avatarUploader () {
    return (
      <AvatarUpload
        key="avatar_url"
        ref="avatarUpload"
        defaultAvatar={''}
        bgColor="gray-light-bg"
        actionFn={this.uploadAvatar}
        actionCb={this.uploadAvatarCb}
        showRequired={false}
        inputFieldName="avatar_url"
      />
    );
  }

  avatarForm () {
    const { showButton, errorMsg } = this.state;
    const inputData = [
      {
        custom: this.avatarUploader
      }
    ];
    return (
      <div>
        <FormBuilder
          ref="avatarUploadForm"
          formname="profile form"
          formStyle="modal"
          formInputs={inputData}
          heading=""
          description=""
          errorText={errorMsg}
          submitAction={this.submitPhoto}
          submitCallback={this.submitPhotoCb}
          btnColSize={`col-xs-12 ${!showButton ? 'hidden' : ''}`}
          buttonText="Submit Photo"
        />
        {
          !showButton ?
          <div className="text-center"><a onClick={this.props.skipAction}>Skip</a></div> : null
        }
      </div>
    );
  }

  render () {
    return (
      <BootstrapModal
        {...this.props}
        ref="avatarModal"
        modalClass="avatar-upload-modal"
        header={
          this.props.header || <h4>Add your photo so others can easily recognize you</h4>
        }
        body={this.avatarForm()}
      />
    );
  }
}
